// Simple booking API using JSONBin.io (free service)
// 🚀 SETUP INSTRUCTIONS:
// 1. Go to https://jsonbin.io and sign up (free)
// 2. Create a new bin
// 3. Replace the values below with your actual API key and bin ID

// 🔧 CONFIGURATION - Your JSONBin.io credentials:
const API_KEY = '$2a$10$BI7BF4mmNV5VFWZJUE43resogA3XcQYdMKg1f.i07CgcJWO8LVXlG'; // ✅ Your X-Master-Key
const BIN_ID = '6843fe5f8960c979a5a62d83'; // ✅ Your bin ID

const API_BASE = 'https://api.jsonbin.io/v3/b';

// 🧪 Demo mode fallback (uses localStorage if API not configured)
const isDemoMode = API_KEY.includes('DEMO') || BIN_ID.includes('DEMO');

export const bookingAPI = {
  // Get all bookings
  async getBookings() {
    if (isDemoMode) {
      // Fallback to localStorage in demo mode
      const stored = localStorage.getItem('movie-bookings');
      return stored ? JSON.parse(stored) : [];
    }

        try {
      console.log('🔄 Fetching bookings from JSONBin...');
      const response = await fetch(`${API_BASE}/${BIN_ID}/latest`, {
        method: 'GET',
        headers: {
          'X-Master-Key': API_KEY,
          'Content-Type': 'application/json'
        }
      });

      console.log('📡 Response status:', response.status);
      console.log('📡 Response headers:', Object.fromEntries(response.headers.entries()));

      if (!response.ok) {
        const errorText = await response.text();
        console.error('📡 Error response:', errorText);
        throw new Error(`HTTP error! status: ${response.status} - ${errorText}`);
      }

      const data = await response.json();
      console.log('📦 Data received:', data);

      const bookings = data.record?.bookings || [];
      console.log('✅ Bookings loaded:', bookings.length, 'bookings');
      return bookings;
    } catch (error) {
      console.error('❌ Error fetching bookings:', error);
      console.error('❌ Error details:', error.message);

      // Fallback to localStorage if API fails
      console.log('🔄 Falling back to localStorage...');
      const stored = localStorage.getItem('movie-bookings');
      return stored ? JSON.parse(stored) : [];
    }
  },

  // Save all bookings
  async saveBookings(bookings) {
    if (isDemoMode) {
      // Fallback to localStorage in demo mode
      localStorage.setItem('movie-bookings', JSON.stringify(bookings));
      return true;
    }

    try {
      console.log('💾 Saving bookings to JSONBin...');
      const response = await fetch(`${API_BASE}/${BIN_ID}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Master-Key': API_KEY
        },
        body: JSON.stringify({ bookings })
      });

      console.log('💾 Save response status:', response.status);

      if (response.ok) {
        console.log('✅ Bookings saved successfully');
        // Also save to localStorage as backup
        localStorage.setItem('movie-bookings', JSON.stringify(bookings));
      }

      return response.ok;
    } catch (error) {
      console.error('❌ Error saving bookings:', error);
      // Fallback to localStorage if API fails
      localStorage.setItem('movie-bookings', JSON.stringify(bookings));
      return true; // Return true since we saved to localStorage
    }
  },

  // Add a new booking
  async addBooking(booking) {
    const bookings = await this.getBookings();

    // Check for conflicts
    const conflict = bookings.find(b => b.seatId === booking.seatId);
    if (conflict) {
      throw new Error(`Seat ${booking.seatId} is already booked by ${conflict.name}`);
    }

    const newBooking = {
      ...booking,
      timestamp: new Date().toISOString(),
      id: `booking_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`
    };

    bookings.push(newBooking);

    const success = await this.saveBookings(bookings);
    if (!success) {
      throw new Error('Failed to save booking');
    }

    return newBooking;
  }
};

// 🎯 Status check
console.log(isDemoMode ?
  '🧪 DEMO MODE: Using localStorage. Replace API_KEY and BIN_ID with real values for multi-location access!' :
  '🌍 LIVE MODE: Using JSONBin.io for multi-location access!'
);
